import { render, staticRenderFns } from "./OrderItemsPlacedPieChart.vue?vue&type=template&id=0456f795"
import script from "./OrderItemsPlacedPieChart.vue?vue&type=script&lang=js"
export * from "./OrderItemsPlacedPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports